import { auth0Roles } from './config'
import cookie from 'react-cookies'
import cookies from 'react-cookies'
import { geocodeByPlaceId } from 'react-google-places-autocomplete'
import { isBoolean, isNil } from 'lodash'
import sanitizeHtml from 'sanitize-html'
import { isBrowser } from './config'
import { SANITIZE_DESCRIPTION } from './data'

let user = cookie.load('user')
const globalData = require('../globalData.json')

const GRACE_PERIOD = 28

export const removeDuplicates = (array, key) => {
  return array.filter(
    (obj, index, self) => index === self.findIndex(el => el[key] === obj[key])
  )
}

export const IsUserLoggedIn = () => {
  let user = cookies.load('user')
  if (user) {
    return true
  }
  return false
}

export const cleanObject = obj => {
  for (var propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === '' ||
      obj[propName] === false ||
      obj[propName]?.length === 0
    ) {
      delete obj[propName]
    }
  }

  return obj
}

export const restructorArray = (array, length) => {
  let size = 0,
    subArray = []
  const parentArray = []
  array?.forEach((each, index) => {
    subArray.push(each)
    size++
    if (size === length) {
      parentArray.push(subArray)
      size = 0
      subArray = []
    }
  })
  subArray.length && parentArray.push(subArray)
  return parentArray
}

export const formatPrice = (amount, currency) => {
  if (amount) {
    amount = parseFloat(amount)
  }

  let numberFormat = new Intl.NumberFormat(['en-US'], {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  })
  return numberFormat.format(amount)
}

export const formatCurrency = value => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
  return formatter.format(value)
}

export const permissionsHandler = (userSubscriptions, userRole) => {
  let _subs = userSubscriptions || {}
  let today = new Date()

  if (userRole === auth0Roles?.Member?.id) {
    let memberData = {
      subscriptionPurchased: false,
      currentSubscription: null,
      isSubscriptionCancelled: false,
    }
    if (_subs?.subscribedProducts?.length) {
      let latestSubscribedProduct = _subs?.subscribedProducts.sort(
        (a, b) => b.id - a.id
      )[0]

      if (latestSubscribedProduct?.expiry) {
        let productExpiry = new Date(latestSubscribedProduct?.expiry)

        const gracePeriod = latestSubscribedProduct?.cancelled_at
          ? 0
          : GRACE_PERIOD
        let expiryDateWithGrace = new Date(
          productExpiry.setDate(productExpiry.getDate() + gracePeriod)
        )
        memberData.subscriptionPurchased = today < expiryDateWithGrace
      }

      memberData.subscription = latestSubscribedProduct
        ? latestSubscribedProduct
        : null

      memberData.currentSubscription = latestSubscribedProduct.price
      memberData.isSubscriptionCancelled =
        latestSubscribedProduct.cancelled_at == null ? false : true
    }
    return memberData
  } else if (
    userRole === auth0Roles?.Employer?.id ||
    userRole === auth0Roles?.NamedUser?.id
  ) {
    const latestSubscribedProduct = _subs?.subscribedProducts?.sort(
      (a, b) => b.id - a.id
    )

    let subscription = latestSubscribedProduct?.find(
      item => item?.price?.credit_type?.type === 'subscription'
    )

    let resumeSearch = _subs?.subscribedProducts?.find(
      item =>
        item?.price?.credit_type?.type === 'resumeSearch' &&
        new Date(item?.expiry_with_grace) >= new Date()
    )

    let addonSubscriptions = _subs?.subscribedProducts?.filter(
      item =>
        item?.price?.credit_type?.type === 'addonSubscription' &&
        new Date(item?.expiry_with_grace) >= new Date()
    )

    let employerData = {
      subscriptionPurchased: false,
      isSubscriptionCancelled:
        subscription?.cancelled_at == null ? false : true,
      allowResumeSearch: resumeSearch ? resumeSearch : false,
      addonSubscriptions:
        (addonSubscriptions || []).length > 0 ? addonSubscriptions : null,
      singleJob:
        _subs?.credits?.filter(item => item.credit_type?.type === 'singleJob')
          ?.length || null,
      featuredJob:
        _subs?.credits?.filter(item => item.credit_type?.type === 'featuredJob')
          ?.length || null,
    }

    if (subscription && subscription?.expiry) {
      let productExpiry = new Date(subscription?.expiry)
      const gracePeroid = subscription?.cancelled_at ? 0 : GRACE_PERIOD
      let expiryDateWithGrace = new Date(
        productExpiry.setDate(productExpiry.getDate() + gracePeroid)
      )
      employerData.subscriptionPurchased =
        today < expiryDateWithGrace ? subscription : false
    }

    return employerData
  }
}

export const nameReturnHandler = userProfile => {
  if (user) {
    if (user.role.id === auth0Roles.Member.id) {
      if (userProfile.name) {
        return {
          name: userProfile.name,
          letter: userProfile?.name.charAt(0).toUpperCase(),
        }
      } else {
        return {
          name: userProfile.username,
          letter: userProfile?.username.charAt(0).toUpperCase(),
        }
      }
    } else {
      if (userProfile.name) {
        return {
          name: userProfile.name,
          letter: userProfile?.name.charAt(0).toUpperCase(),
        }
      } else {
        return {
          name: userProfile.username,
          letter: userProfile?.username.charAt(0).toUpperCase(),
        }
      }
    }
  }
}

export function abbrNum(number, decPlaces) {
  if (!number) {
    return 0
  } else {
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces)

    // Enumerate number abbreviations
    var abbrev = ['k', 'm', 'b', 't']

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {
      // Convert array index to "1000", "1000000", etc
      var size = Math.pow(10, (i + 1) * 3)

      // If the number is bigger or equal do the abbreviation
      if (size <= number) {
        // Here, we multiply by decPlaces, round, and then divide by decPlaces.
        // This gives us nice rounding to a particular decimal place.
        number = Math.round((number * decPlaces) / size) / decPlaces

        // Handle special case where we round up to the next abbreviation
        if (number === 1000 && i < abbrev.length - 1) {
          number = 1
          i++
        }

        // Add the letter for the abbreviation
        number += abbrev[i]

        // We are done... stop
        break
      }
    }

    return number
  }
}

function generateValue(value) {
  if (isBoolean(value)) {
    if (value) {
      return true
    } else {
      return false
    }
  }

  return value || parseInt(value) === 0 ? value : ''
}

export const serialize = function (obj) {
  var str = []
  for (var p in obj) {
    if (!isNil(obj[p]) && obj[p] !== '') {
      str.push(
        encodeURIComponent(p) + '=' + encodeURIComponent(generateValue(obj[p]))
      )
    }
  }

  return str.join('&')
}

export const displayValueHandler = value => {
  value = value.split('_p_').join(' + ')
  value = value.split('/').join('_or_')
  value = value.split('_and_').join('&')
  value = value.split('_').join(' ')
  return value
}

export const restructureJob = job => {
  if (!job) return null
  let returnedJob = {}
  if (job.application_method) {
    returnedJob.application_method = job.application_method
  }

  if (job.remote_enabled) {
    returnedJob.remote_enabled = job.remote_enabled

    let jobLocation
    if (job?.location && Array.isArray(job?.location)) {
      jobLocation = job.location[0]
    } else {
      jobLocation = job.location
    }
    returnedJob.location =
      job?.formattedAddress || jobLocation?.location?.formattedAddress
        ? job?.formattedAddress ||
          jobLocation?.location?.formattedAddress + ' - Remote'
        : 'Remote'
  } else {
    let jobLocation
    if (job?.location && Array.isArray(job?.location)) {
      jobLocation = job.location[0]
    } else {
      jobLocation = job.location
    }

    if (job?.formattedAddress || jobLocation?.location?.formattedAddress) {
      let location = ''
      if (job?.formattedAddress || jobLocation?.location?.formattedAddress) {
        location = `${
          job?.formattedAddress || jobLocation?.location?.formattedAddress
        }`
      }
      returnedJob.location = location
    } else {
      returnedJob.location = 'Not Specified'
    }
  }

  if (job._geoloc) {
    returnedJob._geoloc = job._geoloc
  }
  if (job.fullAddress) {
    returnedJob.fullAddress = job.fullAddress
  }
  // primary_function
  if (job.primary_function) {
    returnedJob.primary_function = displayValueHandler(job.primary_function)
  } else {
    returnedJob.primary_function = 'Not Specified'
  }
  // job_functions
  if (job.job_functions) {
    returnedJob.job_functions = displayValueHandler(job.job_functions)
  } else {
    returnedJob.job_functions = 'Not Specified'
  }
  // product Category
  if (job.product_category) {
    returnedJob.product_category = displayValueHandler(job.product_category)
  } else {
    returnedJob.product_category = 'Not Specified'
  }
  // If Industry
  if (job.industry) {
    returnedJob.industry = displayValueHandler(job.industry)
  } else {
    returnedJob.industry = 'Not Specified'
  }
  // maxSalary
  if (job.maxSalary) {
    returnedJob.maxSalary = job.maxSalary
  } else {
    returnedJob.maxSalary = 0
  }
  // minSalary
  if (job.minSalary) {
    returnedJob.minSalary = job.minSalary
  } else {
    returnedJob.minSalary = 0
  }
  // min_compensation
  if (job.min_compensation) {
    returnedJob.min_compensation = job.min_compensation
  } else {
    returnedJob.min_compensation = 0
  }
  // max_compensation
  if (job.max_compensation) {
    returnedJob.max_compensation = job.max_compensation
  } else {
    returnedJob.max_compensation = 0
  }
  // compensation_type
  if (job.compensation_type) {
    returnedJob.compensation_type = displayValueHandler(job.compensation_type)
  } else {
    returnedJob.compensation_type = 'Not Specified'
  }
  if (job.description) {
    returnedJob.description = job.description
  } else {
    returnedJob.description = 'Not Specified'
  }
  if (job.employer) {
    returnedJob.employer = job?.employer?.name
    returnedJob.employerDetails = job.employer
  } else {
    returnedJob.employer = 'Not Specified'
  }
  if (job.applications?.length) {
    returnedJob.applicationsLength = job.applications.length
  } else {
    returnedJob.applicationsLength = '0'
  }
  if (job.job_code) {
    returnedJob.job_code = job.job_code
  } else {
    returnedJob.job_code = 'Not Specified'
  }
  if (job.travel_percentage) {
    returnedJob.travel_percentage = job.travel_percentage
  } else {
    returnedJob.travel_percentage = 'Not Specified'
  }
  if (job.external_redirect_count) {
    returnedJob.external_redirect_count = job.external_redirect_count
  } else {
    returnedJob.external_redirect_count = 'Not Specified'
  }
  returnedJob.external_redirect = job.external_redirect
  returnedJob.applicationUrl = job.applicationUrl
  returnedJob.slug = job.slug
  returnedJob.featured = job.featured
  returnedJob.id = job.objectID || job.id
  returnedJob.title = job.title
  returnedJob.description = job.description
  returnedJob.city = job.city
  returnedJob.state = job.state
  returnedJob.postalCode = job.postalCode
  returnedJob.archived_date = job.archived_date
  returnedJob.published_at = job.published_at
  returnedJob.applied = job.applied
  returnedJob.strapiId = job.strapiId
  returnedJob.exclusive_medreps = job.exclusive_medreps ? true : false
  returnedJob.confidential = job.confidential

  return returnedJob
}

export const restructureJobFromAlgolia = job => {
  if (!job) return null
  let returnedJob = {}
  if (job.application_method) {
    returnedJob.application_method = job.application_method
  }

  if (job.remote_enabled) {
    returnedJob.remote_enabled = job.remote_enabled
    let location = '',
      locationList = [],
      fullAddress
    if (job?.fullAddress && Array.isArray(job?.fullAddress)) {
      fullAddress = job?.fullAddress[0]
      locationList = job.fullAddress.map(
        item => item?.location?.formattedAddress
      )
    } else {
      fullAddress = job?.fullAddress
      locationList = [job?.fullAddress?.location?.formattedAddress]
    }
    locationList.push('Remote')
    if (fullAddress) {
      location = fullAddress?.location?.formattedAddress + ' - Remote'
    } else {
      location = 'Remote'
    }
    returnedJob.location = location
    returnedJob.locationList = locationList
  } else {
    let location = '',
      locationList = [],
      fullAddress
    if (job?.fullAddress && Array.isArray(job?.fullAddress)) {
      fullAddress = job?.fullAddress[0]
      locationList = job.fullAddress.map(
        item => item?.location?.formattedAddress
      )
    } else {
      fullAddress = job?.fullAddress
      locationList = [job?.fullAddress?.location?.formattedAddress]
    }
    if (fullAddress) {
      location = fullAddress?.location?.formattedAddress
    } else {
      location = 'Not Specified'
      locationList.push('Not Specified')
    }

    returnedJob.location = location
    returnedJob.locationList = locationList
  }

  if (job._geoloc) {
    returnedJob._geoloc = job._geoloc
  }
  if (job.fullAddress) {
    returnedJob.fullAddress = job.fullAddress
  }
  // primary_function
  if (job.primary_function) {
    returnedJob.primary_function = displayValueHandler(job.primary_function)
  } else {
    returnedJob.primary_function = 'Not Specified'
  }
  // job_functions
  if (job.job_functions) {
    returnedJob.job_functions = displayValueHandler(job.job_functions)
  } else {
    returnedJob.job_functions = 'Not Specified'
  }
  // product Category
  if (job.product_category) {
    returnedJob.product_category = displayValueHandler(job.product_category)
  } else {
    returnedJob.product_category = 'Not Specified'
  }
  // If Industry
  if (job.industry) {
    returnedJob.industry = displayValueHandler(job.industry)
  } else {
    returnedJob.industry = 'Not Specified'
  }
  // maxSalary
  if (job.maxSalary) {
    returnedJob.maxSalary = job.maxSalary
  } else {
    returnedJob.maxSalary = 0
  }
  // minSalary
  if (job.minSalary) {
    returnedJob.minSalary = job.minSalary
  } else {
    returnedJob.minSalary = 0
  }
  // min_compensation
  if (job.min_compensation) {
    returnedJob.min_compensation = job.min_compensation
  } else {
    returnedJob.min_compensation = 0
  }
  // max_compensation
  if (job.max_compensation) {
    returnedJob.max_compensation = job.max_compensation
  } else {
    returnedJob.max_compensation = 0
  }
  // compensation_type
  if (job.compensation_type) {
    returnedJob.compensation_type = displayValueHandler(job.compensation_type)
  } else {
    returnedJob.compensation_type = 'Not Specified'
  }
  if (job.description) {
    returnedJob.description = job.description
  } else {
    returnedJob.description = 'Not Specified'
  }
  if (job.employer) {
    returnedJob.employer = job?.employer?.name
    returnedJob.employerDetails = job.employer
  } else {
    returnedJob.employer = 'Not Specified'
  }
  if (job.applications?.length) {
    returnedJob.applicationsLength = job.applications.length
  } else {
    returnedJob.applicationsLength = '0'
  }
  if (job.job_code) {
    returnedJob.job_code = job.job_code
  } else {
    returnedJob.job_code = 'Not Specified'
  }
  if (job.travel_percentage) {
    returnedJob.travel_percentage = job.travel_percentage
  } else {
    returnedJob.travel_percentage = 'Not Specified'
  }
  if (job.external_redirect_count) {
    returnedJob.external_redirect_count = job.external_redirect_count
  } else {
    returnedJob.external_redirect_count = 'Not Specified'
  }
  returnedJob.external_redirect = job.external_redirect

  returnedJob.applicationUrl = job.applicationUrl
  returnedJob.exclusive_medreps = job.exclusive_medreps
  returnedJob.slug = job.slug
  returnedJob.featured = job.featured
  returnedJob.id = job.objectID || job.id
  returnedJob.title = job.title
  returnedJob.description = job.description
  returnedJob.city = job.city
  returnedJob.state = job.state
  returnedJob.postalCode = job.postalCode
  returnedJob.archived_date = job.archived_date
  returnedJob.published_at = job.published_at
  returnedJob.applied = job.applied
  returnedJob.confidential = job.confidential

  return returnedJob
}

// Date format handler
function ordinal(number) {
  const english_ordinal_rules = new Intl.PluralRules('en', {
    type: 'ordinal',
  })
  const suffixes = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
  }

  const suffix = suffixes[english_ordinal_rules.select(number)]
  return number + suffix
}

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const dateFormatHandler = (date, hideYear, showFullMonth) => {
  let _date = date ? new Date(date).toDateString().split(' ') : new Date()
  if (hideYear) {
    if (showFullMonth) {
      return (
        monthNames[new Date(date).getMonth()] +
        ' ' +
        ordinal(_date[2][0] === '0' ? _date[2][1] : _date[2])
      )
    }
    return (
      _date[1] + ' ' + ordinal(_date[2][0] === '0' ? _date[2][1] : _date[2])
    )
  }
  return (
    _date[1] +
    ' ' +
    ordinal(_date[2][0] === '0' ? _date[2][1] : _date[2]) +
    ', ' +
    _date[3]
  )
}

export const dateFormatCustomHandler = (date, hideYear, showFullMonth) => {
  let _date = date ? new Date(date).toDateString().split(' ') : new Date()
  if (hideYear) {
    if (showFullMonth) {
      return (
        monthNames[new Date(date).getMonth()] +
        ' ' +
        (_date[2][0] === '0' ? _date[2][1] : _date[2])
      )
    }
    return _date[1] + ' ' + (_date[2][0] === '0' ? _date[2][1] : _date[2])
  }
  return (
    _date[1] +
    ' ' +
    (_date[2][0] === '0' ? _date[2][1] : _date[2]) +
    ', ' +
    _date[3]
  )
}

export const usDateFormat = (date, divider) => {
  if (!date || date === 'Not Specified') {
    return 'Not Specified'
  }
  let _divider = divider === 'line' ? '-' : '/'
  let _date = date?.split('-')
  return _date[1] + _divider + _date[2] + _divider + _date[0]
}

export const returnCreditType = id => {
  return globalData?.creditTypes?.find(item => item.id === id)
}

export const getAddressObject = address_components => {
  const ShouldBeComponent = {
    street_number: ['street_number'],
    postal_code: ['postal_code'],
    street: ['street_address', 'route'],
    state: [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'administrative_area_level_4',
      'administrative_area_level_5',
    ],
    city: [
      'locality',
      'sublocality',
      'sublocality_level_1',
      'sublocality_level_2',
      'sublocality_level_3',
      'sublocality_level_4',
    ],
    country: ['country'],
  }

  let address = {
    street_number: '',
    postal_code: '',
    street: '',
    state: '',
    city: '',
    country: '',
  }

  address_components.forEach(component => {
    for (var shouldBe in ShouldBeComponent) {
      if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
        if (shouldBe === 'country' || shouldBe === 'state') {
          address[shouldBe] = component.short_name
        } else {
          address[shouldBe] = component.long_name
        }
      }
    }
  })

  // Fix the shape to match our schema
  address.address = address.street_number + ' ' + address.street
  delete address.street_number
  delete address.street

  return address
}

export const getDecodedLocation = async place_id => {
  const geocodeData = await geocodeByPlaceId(place_id)
  if (geocodeData[0]) {
    const addressObject = getAddressObject(geocodeData[0].address_components)
    const locationObject = {
      ...addressObject,
      formattedAddress: geocodeData[0].formatted_address,
      latitude: geocodeData[0].geometry.location.lat(),
      longitude: geocodeData[0].geometry.location.lng(),
      place_id: place_id,
    }
    return locationObject
  } else {
    return null
  }
}

// Crop Image
export const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

export function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
export function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation)

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  }
}

export async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false }
) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    return null
  }

  const rotRad = getRadianAngle(rotation)

  // calculate bounding box of the rotated image
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
    image.width,
    image.height,
    rotation
  )

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth
  canvas.height = bBoxHeight

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
  ctx.rotate(rotRad)
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
  ctx.translate(-image.width / 2, -image.height / 2)

  // draw rotated image
  ctx.drawImage(image, 0, 0)

  // croppedAreaPixels values are bounding box relative
  // extract the cropped image using these values
  const data = ctx.getImageData(
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height
  )

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  // paste generated rotate image at the top left corner
  ctx.putImageData(data, 0, 0)

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(file => {
      resolve(file)
    }, 'image/png')
  })
}

export async function getRotatedImage(imageSrc, rotation = 0) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const orientationChanged =
    rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270
  if (orientationChanged) {
    canvas.width = image.height
    canvas.height = image.width
  } else {
    canvas.width = image.width
    canvas.height = image.height
  }

  ctx.translate(canvas.width / 2, canvas.height / 2)
  ctx.rotate((rotation * Math.PI) / 180)
  ctx.drawImage(image, -image.width / 2, -image.height / 2)

  return new Promise(resolve => {
    canvas.toBlob(file => {
      resolve(URL.createObjectURL(file))
    }, 'image/png')
  })
}

export const getDescription = str => {
  if (!document) return str

  const jobDescription = sanitizeHtml(str, SANITIZE_DESCRIPTION)

  let tempElement = document.createElement('div')
  tempElement.innerHTML = jobDescription
  let anchorTags = tempElement.getElementsByTagName('a')

  for (let i = 0; i < anchorTags.length; i++) {
    let href = anchorTags[i].getAttribute('href')

    if (href && !/^https?:\/\//i.test(href)) {
      anchorTags[i].setAttribute('href', 'https://' + href)
    }
  }

  let modifiedHtmlContent = tempElement.innerHTML
  return modifiedHtmlContent
}

export const pushGTMEvent = payload => {
  if (!isBrowser()) return

  const dataLayer = window.dataLayer || []
  dataLayer.push({
    event: 'GTMevent',
    ...payload,
  })
}
